import { BranchLogo } from '@branch-messenger/willow-ui/icons'
import { AppStore } from '@components/Icons/AppStore'
import { PlayStore } from '@components/Icons/PlayStore'
import { useOrgTheme } from '@hooks/useOrgTheme'
import { fireMixpanelEvent } from '@lib/analytics'
import { useWhiteLabelAppDetails } from '@src/queries/org'

import {
  StyledAppHeaderContainer,
  StyledHeaderAppStoreContainer,
} from './styles'

export const AppHeader = () => {
  const theme = useOrgTheme()
  const { data: appInfo } = useWhiteLabelAppDetails()
  return (
    <StyledAppHeaderContainer>
      <div>
        {theme.logo ? (
          <img src={theme.logo} alt="logo" />
        ) : (
          <BranchLogo height={40} width={'100%'} />
        )}
      </div>
      <StyledHeaderAppStoreContainer>
        <a
          href={appInfo?.app_store_url}
          target="_blank"
          onClick={() => fireMixpanelEvent('header|download:ios.tap')}
          rel="noopener noreferrer"
        >
          <AppStore />
        </a>
        <a
          href={appInfo?.google_play_url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => fireMixpanelEvent('header|download:android.tap')}
        >
          <PlayStore />
        </a>
      </StyledHeaderAppStoreContainer>
    </StyledAppHeaderContainer>
  )
}
